<template>
  <YapModal :set-is-open="setIsOpen" wide @modal-closed="$emit('modalClosed')">
    <template #title>
      <div class="flex items-center gap-2">
        <span>{{ state.fileResource?.displayName }}</span>
        <EditFileResourceNameModal
          v-if="state.fileResource"
          :file-resource="state.fileResource"
          @update="handleRename"
        />
        <YapFileResourceDownloadButton v-if="state.fileResource" :file-resource="state.fileResource" />
      </div>
    </template>
    <template #default>
      <img
        v-if="file.mime !== MimeTypes.PDF"
        class="block max-h-[40rem] w-full object-contain"
        :src="`${getEnv(EnvironmentTypes.VITE_APP_GW_HOST)}/api/files/${file.fileName}/raw?apiKey=${getEnv(
          EnvironmentTypes.VITE_APP_API_KEY
        )}`"
        :alt="file.originalName"
        :filename="file.originalName"
      />

      <div v-else-if="state.isLoading" class="flex h-full w-full items-center justify-center">
        <YapLoader :size="YapLoaderSizes.Medium" />
      </div>
      <YapPDF v-else-if="state.fileBinaryData" :is-expanded="true" :binary-data="state.fileBinaryData" />
      <YapPDF v-else-if="state.fileBase64Data" :is-expanded="true" :base64-data="state.fileBase64Data" />
    </template>
  </YapModal>
</template>

<script setup lang="ts">
import { onMounted, reactive } from 'vue';

import getEnv from '@/utils/env';
import apiGw from '@/services/apiGw';
import { MimeTypes } from '@/types/general';
import YapPDF from '@/components/YapPDF.vue';
import YapModal from '@/components/YapModal.vue';
import { FileResource } from '@/types/fileResource';
import { EnvironmentTypes } from '@/types/environmentTypes';
import YapLoader, { YapLoaderSizes } from '@/components/YapLoader.vue';
import { FileData } from '@/components/transactions/types/receiptFile';
import EditFileResourceNameModal from '@/components/fileResource/EditFileResourceNameModal.vue';
import YapFileResourceDownloadButton from '@/components/fileResource/YapFileResourceDownloadButton.vue';

const emit = defineEmits(['modalClosed']);
const props = defineProps<{
  setIsOpen: boolean;
  file: FileData;
}>();

interface State {
  fileResource?: FileResource;
  fileBase64Data?: string;
  fileBinaryData?: ArrayBuffer;
  isLoading: boolean;
}

const state: State = reactive({
  fileResource: undefined,
  schema: undefined,
  fileData: undefined,
  isLoading: false
});

onMounted(async () => {
  if (props.file) {
    state.fileResource = (await apiGw.get(`/v2/file-resources/${props.file.resourceUid}`)).data;
    if (!!props.file.data) {
      state.fileBase64Data = props.file.data;
    } else if (props.file.mime === MimeTypes.PDF && !props.file.data) {
      state.isLoading = true;
      const response = await apiGw.get(`/files/${props.file.fileName}/raw`, {
        responseType: 'arraybuffer'
      });
      state.fileBinaryData = response.data;
      state.isLoading = false;
    }
  }
});

function handleRename(data: { resourceUid: string; newName: string }) {
  if (state.fileResource) {
    state.fileResource.displayName = data.newName;
  }
}
</script>
